import { render } from "./MyLoans.vue?vue&type=template&id=6be36bb9"
import script from "./MyLoans.vue?vue&type=script&lang=js"
export * from "./MyLoans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__